import styled from 'styled-components';

export const RandomFactsBox = styled.div`
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
border-radius: 10px;
padding: 1rem .5rem;
background-color: var(--lemon);
 `;